import { FC, useEffect } from 'react';
import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import ArchiveIcon from '@mui/icons-material/Archive';
import LockIcon from '@mui/icons-material/Lock';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { getContentDownloadUrl } from '../../../../apiRPC/content/downloadUrl';
import * as React from 'react';
import { useUnit } from 'effector-react';
import { setMenuView } from '../model';
import { TitleItem } from '../TitleItem';
import { $board, updateBoardFX } from '../../../model/board';
import { $hasCyrillicCard } from '../../../model/card/hasCyrillicCard';
import { onStartListening } from '../CardArchival/model';

export const DefaultMenu: FC = () => {
  const board = useUnit($board);
  const hasCyrillicCard = useUnit($hasCyrillicCard);

  useEffect(() => {
    onStartListening({ filter: {} });
  }, []);

  const handleToggleCyrillic = () => {
    if (!board) return;
    updateBoardFX({
      uuid: board.uuid,
      fields: {
        cardsHaveCyrillicTitles: !(board.cardsHaveCyrillicTitles ?? true),
      },
    });
  };

  return (
    <>
      <TitleItem title="Меню" />

      <List>
        <ListItem disablePadding divider>
          <ListItemButton
            onClick={() => setMenuView('CardArchival')}
            id="rMenuCardArchival"
          >
            <ListItemIcon>
              <ArchiveIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Архив" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding divider>
          <ListItemButton
            component="a"
            href={
              board ? getContentDownloadUrl(board.uuid, 'board') : undefined
            }
            rel="noopener noreferrer"
            disabled={!board}
            id="rMenuDownloadPdf"
          >
            <ListItemIcon>
              <PictureAsPdfIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Скачать PDF" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding divider>
          <ListItemButton onClick={() => setMenuView('Acces')}>
            <ListItemIcon>
              <LockIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Редактировать доступ" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding divider>
          <Tooltip
            title={
              hasCyrillicCard
                ? 'На доске есть карточки с кириллицей в заголовке'
                : ''
            }
            placement="left"
            arrow
            disableHoverListener={!hasCyrillicCard}
          >
            <span className="tooltip-wrapper">
              <ListItemButton
                onClick={handleToggleCyrillic}
                disabled={hasCyrillicCard}
              >
                <ListItemIcon>
                  <Checkbox
                    checked={board?.cardsHaveCyrillicTitles ?? true}
                    sx={{
                      padding: 0,
                      margin: 0,
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary="Разрешить кириллицу в заголовках карточек" />
              </ListItemButton>
            </span>
          </Tooltip>
        </ListItem>
      </List>
    </>
  );
};
